import React, { useEffect } from 'react';

interface MeetingsEmbedProps {
  url: string;
}

export function HubspotCalendar({ url }: MeetingsEmbedProps) {
  useEffect(() => {
    const script = document.createElement(`script`);
    script.src = `https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="meetings-iframe-container"
      data-src={`${url}?embed=true`}
      style={{ width: `100%`, height: `100%` }}
    />
  );
}
